module.exports = __webpack_public_path__ + "school/img/newVideoTrainingDirectory.d49b4cea.png";